//@flow
import React, { Component } from "react";
import type { ProductType } from "../types/product.js";

type Props = {
  product: ProductType,
  isPricingAvailable: boolean
};

class ButtonAddToCart extends Component<Props> {
  render() {
    const isDisabled = !this.props.isPricingAvailable;
    return (
      <add-to-cart
        data-product-number={this.props.product.productCode}
        data-product-name={this.props.product.title}
        data-quantity={this.props.product.quantity}
        data-unit="ONE"
        disabled={isDisabled ? "disabled" : null}
      >
        Add
      </add-to-cart>
    );
  }
}

export default ButtonAddToCart;
